import { render, staticRenderFns } from "./ReclameAquiNumberOfComplaints.vue?vue&type=template&id=06d33278&"
import script from "./ReclameAquiNumberOfComplaints.vue?vue&type=script&lang=ts&"
export * from "./ReclameAquiNumberOfComplaints.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports